import { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import './main.scss';
import { CustomCheckBox, CustomTable } from '../../../shared/uiComponents';
import { Header } from '../../../components/StyledComponents';
import SearchBar from '../../../components/SearchBar';
import { AdminTypes } from '../../../components/Menu';
import { Container } from '../../SOAPNotes/Admin/helpers';
import { ClinicalSupervisorHeaders, Headers, SoapNoteFilters, TableBody } from './tableInfo';
import Filters from './filters';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getSoapNotesUser } from '../../../redux/State/clientSlice/soapNoteSlice';
import { PageHeader } from '../../../components/PageHeader';
import { Notes } from '../../../shared/Assets/menuIcons';

const UserSoapNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params, setParams] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const direction = params.get('direction') || '';
	const orderBy = params.get('orderBy') || '';
	const status = params.get('status') || '';
	const searchString = params.get('search') || '';
	const includeBtSessions = params.get('includeBtSessions') !== 'false';
	const sessionType = params.get('sessionType') || '';

	const soapNotes = useSelector((state) => state.soapNote.soapNotes);
	const role = useSelector((state) => state.account.role);

	const loading = useSelector((state) => state.soapNote.loading);
	const filterData = useSelector((state) => state.billing.billingFilters);
	const userId = useSelector((state) => state.account.user.id);

	useEffect(() => {
		if (!userId) return;
		const { startDate, endDate, clientId } = filterData;
		const btId = filterData.userId;

		if (!startDate || !endDate) return;
		dispatch(
			getSoapNotesUser({
				userId: btId ? btId : userId,
				clientId,
				page,
				pageSize,
				direction,
				orderBy,
				searchString,
				status,
				startDate,
				endDate,
				includeBtSessions,
				sessionType,
			}),
		);
	}, [
		page,
		pageSize,
		direction,
		orderBy,
		searchString,
		status,
		userId,
		filterData,
		includeBtSessions,
		sessionType,
		dispatch,
	]);

	const includeBtSessionsHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		params.set('includeBtSessions', `${checked}`);
		setParams(params, { replace: true });
	};

	const headers = role?.section.id === AdminTypes.cs ? ClinicalSupervisorHeaders : Headers;
	const isBT = role?.section.id === AdminTypes.bt;

	return (
		<Container>
			<PageHeader icon={<Notes />} title="SOAP Notes" isInContainer customStyles={{ marginBottom: '24px' }} />
			<Header style={{ marginBottom: 0 }}>
				<Filters />
			</Header>
			<div style={{ display: 'flex', gap: 16, marginBottom: '16px' }}>
				{!isBT && (
					<CustomCheckBox
						item={{
							id: '0',
							checked: includeBtSessions,
							label: 'Include BT Sessions',
						}}
						onChange={includeBtSessionsHandler}
						style={{ marginTop: '24px' }}
					/>
				)}
				<SearchBar hasFilter style={{ marginTop: '16px' }} />
				<SoapNoteFilters />
			</div>
			<CustomTable headers={headers} data={soapNotes} TableBody={TableBody} loading={loading} />
		</Container>
	);
};

export default UserSoapNotes;
